import React, { PureComponent } from "react";
import TeamReportsCard from "./card";
import EventEmitter from "../../../services/event-emitter";

class TeamReportsLeftNavigation extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      section: 1
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  componentDidMount() {
    this.eventemitter.on("team-reports-change-section", this.changeSection);
  }

  componentWillUnmount() {
    this.eventemitter.off("team-reports-change-section", this.changeSection);
  }

  changeSection = section => {
    this.setState({
      section
    });
  };

  render() {
    const { section } = this.state;

    return (
      <aside className="aside aside-team-reports">
        <div className="inner-sidebar">
          <TeamReportsCard
            section={1}
            title="MG Team Reports"
            active={section === 1}
          />
          <TeamReportsCard
            section={2}
            title="Grades & Ranks"
            active={section === 2}
          />
          <TeamReportsCard
            section={3}
            title="Financial Planning & Analysis"
            active={section === 3}
          />
          <TeamReportsCard
            section={4}
            title="Market Analysis"
            active={section === 4}
          />
          <TeamReportsCard
            section={5}
            title="Operational Analysis"
            active={section === 5}
          />
          <TeamReportsCard
            section={6}
            title="Financing Analysis"
            active={section === 6}
          />
          <TeamReportsCard
            section={7}
            title="Financial Reports"
            active={section === 7}
          />
        </div>
      </aside>
    );
  }
}

export default TeamReportsLeftNavigation;



// WEBPACK FOOTER //
// ./src/components/team-reports/navigation/left.js